export default "__VITE_ASSET__HdodqSej__"